import { Box, Divider, Link, Stack } from "@mui/material";
import { InvestButton } from "src/components/common/buttons/innvest-button/invest-button";
import { SavingsPlanButton } from "src/components/common/buttons/savings-plan-button/savings-plan-button";
import { CBDetailsAccordion } from "../components/details-accordion";
import { CBFooter } from "../components/footer";
import { CBHeader } from "../components/header/header";
import { CBInvestedCapital } from "../components/invested-capital";
import { CBIsin } from "../components/isin";
import { CBPrices } from "../components/prices";
import { CBRatioTabBar } from "../components/ratio-tab-bar";
import { SpacedContainer } from "../components/spaced-container";
import { CBCertificateFee, CBEmission, CBLiquidationFigure, CBPerformanceFee, CBTradingVolume, CBExchangeRatio } from "../components/statistics";
import { useCertificateBoxContext } from "../context";

const END_AGREEMENT_TEST_ID = "end-agreement";
const LINK_PROSPECT_TEST_ID = "link-prospect";

export const CertificateBoxInvestable = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;
    const isPrimaryCertificate = certificate.isPrimary;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <Stack sx={{ gap: 1 }}>
                    <CBPrices />
                    <CBIsin />
                </Stack>

                <Divider />

                <Stack sx={{ gap: 1 }}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Stack>

                <Divider />

                <CBDetailsAccordion>
                    <Stack spacing={2} divider={<Divider />}>
                        <Stack sx={{ gap: 1 }}>
                            <CBEmission />
                            <CBLiquidationFigure />
                            <CBTradingVolume />
                            {isHiddenCertificate && <CBExchangeRatio />}
                        </Stack>
                        <Stack
                            sx={{
                                gap: 1,
                                alignItems: "flex-start",
                            }}
                        >
                            <Link
                                fontSize="2xs"
                                underline="hover"
                                href={certificate.endAgreementUrl!}
                                target="_blank"
                                rel="noreferrer noopener"
                                data-test-id={END_AGREEMENT_TEST_ID}
                            >
                                {dict.endAgreementText}
                            </Link>

                            <Link
                                fontSize="2xs"
                                underline="hover"
                                href={certificate.linkProspectUrl!}
                                target="_blank"
                                rel="noreferrer noopener"
                                data-test-id={LINK_PROSPECT_TEST_ID}
                            >
                                {dict.linkProspectText}
                            </Link>
                        </Stack>
                    </Stack>
                </CBDetailsAccordion>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <InvestButton
                        wikifolioId={data.wikifolio.id}
                        isin={certificate.isin}
                        wikifolioSecurityId={certificate.wikifolioSecurityId}
                        wkn={certificate.wkn}
                        w="100%"
                        colorScheme="green"
                        size="md"
                    >
                        {dict.investNow}
                    </InvestButton>
                    {certificate.showSavingsPlanButton && isPrimaryCertificate && (
                        <SavingsPlanButton
                            wikifolioId={data.wikifolio.id}
                            isin={certificate.isin}
                            wikifolioSecurityId={certificate.wikifolioSecurityId!}
                            wkn={certificate.wkn}
                            w="100%"
                            variant="outline"
                            size="md"
                        >
                            {dict.createSavingPlan}
                        </SavingsPlanButton>
                    )}
                </Box>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
